jQuery(function ($) {
  const $menuButton   = $('.open-menu-btn');
  const $mobileMenu   = $('.mobile-menu');
  const $menuIcon     = $('.menu');
  const $closeIcon    = $('.close');
  const $body         = $('body');

  function openMenu() {
    $mobileMenu.addClass('open');
    $menuIcon.addClass('hidden');
    $closeIcon.removeClass('hidden');
    $body.addClass('overflow-hidden');
  }

  function closeMenu() {
    $mobileMenu.removeClass('open');
    $menuIcon.removeClass('hidden');
    $closeIcon.addClass('hidden');
    $body.removeClass('overflow-hidden');
  }

  $menuButton.on('click', function () {
    if ($mobileMenu.hasClass('open')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  $(window).on('resize', function () {
    if ($(window).width() >= breakpoint && ! $nav.hasClass('hidden')) {
      closeMenu();
    }
  });
});
